// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"notes-print_wrapper__6cIrz","title":"notes-print_title__3mXkU"};